export const blockIconsActivitiesAirNew = (
	<span className='material-symbols-outlined'>air</span>
);
